/**
 * 用户管理服务
 */

import { httpClient } from './httpClient';
import { API_ENDPOINTS } from './api/config';

export const userService = {
  async getList(params: any) {
    return httpClient.get(API_ENDPOINTS.USER.LIST, { params });
  },
  
  async getById(id: number) {
    return httpClient.get(`${API_ENDPOINTS.USER.DETAIL}/${id}`);
  },
  
  async create(data: any) {
    return httpClient.post(API_ENDPOINTS.USER.CREATE, data);
  },
  
  async update(data: any) {
    return httpClient.put(API_ENDPOINTS.USER.UPDATE, data);
  },
  
  async delete(id: number) {
    return httpClient.delete(`${API_ENDPOINTS.USER.DELETE}/${id}`);
  },
  
  async batchDelete(ids: number[]) {
    return httpClient.delete(`${API_ENDPOINTS.USER.DELETE}/batch`, { data: ids });
  },
  
  async changePassword(data: { userId: number; oldPassword: string; newPassword: string }) {
    return httpClient.put(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, data);
  },
  
  async resetPassword(id: number, newPassword: string) {
    return httpClient.post(`${API_ENDPOINTS.USER.DETAIL}/${id}/reset-password`, { newPassword });
  }
};

export default userService;







